import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import { v4 as uuid } from 'uuid';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import ActionButton from '../../components/ActionButton';
import DivContainer from '../../components/DivContainer';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import YesNoDialog from '../../components/YesNoDialog';
import SettingService from '../../services/SettingService';
import WelcomeSurveyService from '../../services/WelcomeSurveyService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import ListUtils from '../../utils/ListUtils';
import QuestionComponent from './QuestionComponent';
import QuestionModel from './QuestionModel';
import QuizCreateRequest from './QuizCreateRequest';
import QuizDetailsResponse from './QuizDetailsResponse';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
class WelcomeSurveyContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new WelcomeSurveyService());
        this.state = {
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            supportedLocales: [],
            element: props.viewMode === 'NEW' ? new QuizCreateRequest([]) : new QuizDetailsResponse([]),
            parameters: [],
            showPublishDialog: false,
            showConfirmRemoveDialog: false,
        };
        this.settingService = new SettingService();
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.renderQuestions = this.renderQuestions.bind(this);
        this.handleAddQuestion = this.handleAddQuestion.bind(this);
        this.handleRemoveQuestion = this.handleRemoveQuestion.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.createNewAnswerOption = this.createNewAnswerOption.bind(this);
        this.removeAnswerOption = this.removeAnswerOption.bind(this);
        this.onAfterEditAnswerOptions = this.onAfterEditAnswerOptions.bind(this);
        this.moveQuestion = this.moveQuestion.bind(this);
        this.viewMode = this.viewMode.bind(this);
        this.onAfterCoinEdition = this.onAfterCoinEdition.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        this.setState(
            {
                uploadedFile: data.quizIcon,
                element: QuizDetailsResponse.copy(data, this.state.supportedLocales),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    initBeforeSetElement() {
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.viewMode === 'NEW' ? new QuizCreateRequest(supportedLocales) : new QuizDetailsResponse(supportedLocales),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
    }

    getAddSucces() {
        return t('email.create');
    }

    getUpdateSucces() {
        return t('email.update');
    }

    prepareElementBeforeRequest(element) {
        element.translations = Object.assign({}, element.translations);
        return element;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId, locale} = this.state;
        const request = this.prepareElementBeforeRequest(element);
        this.scrollToTop();
        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request, locale, elementId)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderLanguages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }
    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.state?.element?.status?.value === 'DRAFT' && this.props.viewMode === 'VIEW',
            },
            {
                label: t('global.publish'),
                onClick: this.handlePublish,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered: this.state?.element?.status?.value === 'DRAFT' && viewMode === 'VIEW',
            },
            {
                label: t('global.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }
    remove() {
        this.scrollToTop();
        this.service
            .remove(this.state.elementId)
            .then(() => {
                const {backUrl} = this.props;
                this.blockUi();
                this.persistMessage('success', '', t('welcome-survey.successRemove'));
                // window.location.href = backUrl;
                this.props.history.push(backUrl);
            })
            .catch(() => {
                this.setState({showConfirmRemoveDialog: false});
                this.showErrorMessage(t('welcome-survey.removeError'));
                this.unblockUi();
            });
    }

    handlePublish() {
        this.setState({
            showPublishDialog: true,
        });
    }

    publish() {
        this.scrollToTop();

        this.blockUi();
        if (this._isMounted) {
            this.service
                .publish(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('welcome-survey.publishSuccess'));
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch((err) => {
                    this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    this.setState({showPublishDialog: false});
                    this.unblockUi();
                });
        }
    }

    changeLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
        this.beforeUpdateElement('VIEW', elementId, locale);
    }

    viewMode() {
        const {viewMode} = this.props;
        return viewMode === 'NEW' ? viewMode : this.state?.element?.status?.value === 'DRAFT' && viewMode === 'EDIT' ? 'EDIT' : 'VIEW';
    }

    renderLanguages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                insideTable
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    moveQuestion(indexFrom, indexTo) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            let modifiedList = this.state.element.translations[element].questions;
            modifiedList = ListUtils.move(modifiedList, indexFrom, indexTo);
            modifiedList.forEach((a, i) => (a.order = i + 1));
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid quiz-container'>
                {' '}
                <YesNoDialog
                    onChange={this.publish.bind(this)}
                    visible={this.state.showPublishDialog}
                    header={t('welcome-survey.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{t('welcome-survey.publishBody')}</span>
                </YesNoDialog>
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('welcome-survey.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{t('welcome-survey.removeBody')}</span>
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }

    getContainerListName() {
        return 'welcome-survey-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('welcome-survey.listTitle'), url: '/welcome-survey-list'},
            {name: t('welcome-survey.details'), url: `/welcome-survey/details/${this.state.element?.id}/${this.state.locale}`},
        ];
    }

    renderDetails() {
        return (
            <React.Fragment>
                {this.viewMode() !== 'NEW' ? (
                    <div className='row'>
                        <InputTextComponent
                            key='status'
                            id='status'
                            name='status'
                            label={t('welcome-survey.status')}
                            value={this.state.element?.status?.label}
                            colClass='col-md-6'
                        />
                        <InputTextComponent
                            key='active'
                            id='active'
                            name='active'
                            label={t('welcome-survey.active')}
                            value={this.state.element?.active ? t('welcome-survey.activeYes') : t('welcome-survey.activeNo')}
                            colClass='col-md-6'
                        />
                    </div>
                ) : null}
                <div className='row'>
                    <InputCalendarRangeComponent
                        key={'active'}
                        idFrom={'activeFrom'}
                        idTo={'activeTo'}
                        nameTo={'activeTo'}
                        nameFrom={'activeFrom'}
                        label={t('welcome-survey.activityRange')}
                        labelFrom={t('welcome-survey.activityRangeFrom')}
                        labelTo={t('welcome-survey.activityRangeTo')}
                        colClass='col-12'
                        from={this.state.element.activeFrom}
                        to={this.state.element.activeTo}
                        validator={[this.validator, this.validatorDraft]}
                        onChange={this.handleChange}
                        viewMode={'VIEW'}
                        showIcon
                        placeholderFrom='dd-mm-rrrr GG:MM'
                        placeholderTo='dd-mm-rrrr GG:MM'
                        validateViewMode
                        dateFormatMoment='DD-MM-YYYY HH:mm'
                        validatorsToType='after_or_equal_time'
                        rendered={this.state.element?.status?.value !== 'DRAFT' && this.viewMode() !== 'NEW'}
                    />
                    {this.renderQuestions()}
                </div>
            </React.Fragment>
        );
    }

    handleAddQuestion(e) {
        if (e) {
            e.preventDefault();
        }
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        const newUUID = uuid();
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;
            modifiedList.push(new QuestionModel(modifiedList.length + 1, newUUID));
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    handleRemoveQuestion(e, index) {
        if (e) {
            e.preventDefault();
        }
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;
            modifiedList.splice(index, 1);
            modifiedList.forEach((q, i) => (q.order = i + 1));
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    createNewAnswerOption(questionOrderId) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;

            const foundQuestion = modifiedList.find((m) => m.order === questionOrderId);
            if (foundQuestion) {
                const newObject = {
                    order: foundQuestion?.answerOptions?.length + 1,
                    text: '',
                    uuid: uuid(),
                    editor: 'TEXT',
                    editable: true,
                    viewMode: this.viewMode(),
                };
                foundQuestion.answerOptions.push(newObject);
            }
            translations[element].questions = modifiedList;
        });

        this.setState(
            (prevState) => ({
                element: {
                    ...prevState.element,
                    translations,
                },
            }),
            () => console.log('element', this.state.element)
        );
    }

    onAfterCoinEdition(coinsToEarn, questionOrder) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;

            const foundQuestion = modifiedList.find((m) => m.order === questionOrder);
            if (foundQuestion) {
                foundQuestion.coinsToEarn = coinsToEarn;
            }
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    removeAnswerOption(questionOrder, optionOrder) {
        const translations = this.state.element.translations;
        const {supportedLocales} = this.state;
        supportedLocales.forEach((element) => {
            const modifiedList = this.state.element.translations[element].questions;

            const foundQuestion = modifiedList.find((m) => m.order === questionOrder);
            if (foundQuestion) {
                const modifiedOptions = foundQuestion.answerOptions;
                modifiedOptions.splice(optionOrder - 1, 1);
                modifiedOptions.forEach((a, i) => (a.order = i + 1));
                foundQuestion.answerOptions = modifiedOptions;
            }
            translations[element].questions = modifiedList;
        });

        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                translations,
            },
        }));
    }
    onAfterEditAnswerOptions(rowData, event, questionOrderId) {
        if (event.target.type === 'checkbox') {
            const translations = this.state.element.translations;
            const {supportedLocales} = this.state;
            supportedLocales.forEach((element) => {
                const modifiedList = this.state.element.translations[element].questions;
                const foundQuestion = modifiedList.find((m) => m.order === questionOrderId);
                if (foundQuestion) {
                    const modifiedAnswers = foundQuestion.answerOptions;
                    const foundAnswer = modifiedAnswers.find((ao) => ao.order === rowData.order);
                    if (foundAnswer) {
                        foundAnswer.correct = !foundAnswer.correct;
                    }
                    foundQuestion.answerOptions = modifiedAnswers;
                }
                translations[element].questions = modifiedList;
            });
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    translations,
                },
            }));
        }
    }
    renderQuestions() {
        return (
            <DivContainer colClass='col-12'>
                <div className='title-section-container'>
                    <span className='p-label quiz-section-label'>{t('welcome-survey.questionsHeader')}</span>
                </div>
                <div>
                    <div className='row'>
                        <div className='col-12'>
                            <ActionButton
                                label={t('welcome-survey.addQuestionHeader')}
                                className='float-right'
                                key={'next-button'}
                                handleClick={(e) => this.handleAddQuestion()}
                                rendered={this.viewMode() !== 'VIEW'}
                            />
                        </div>
                    </div>
                    <hr id='line-separator' />
                </div>
                {this.state.element?.translations[this.state.locale]?.questions?.map((question, index) => {
                    return (
                        <div className='reorder-list-container' key={`${index}-question-controls`}>
                            <div className='reorder-list-controls'>
                                <ActionButton
                                    iconName='mdi-arrow-up-thick'
                                    iconSide='left'
                                    iconColor='white'
                                    handleClick={() => this.moveQuestion(index, index - 1)}
                                    rendered={index !== 0 && this.viewMode() !== 'VIEW'}
                                />
                                <ActionButton
                                    iconName='mdi-arrow-down-thick'
                                    iconSide='left'
                                    iconColor='white'
                                    handleClick={() => this.moveQuestion(index, index + 1)}
                                    rendered={
                                        this.viewMode() !== 'VIEW' &&
                                        index !== this.state.element?.translations[this.state.locale]?.questions.length - 1
                                    }
                                />
                            </div>
                            <div className='reorder-list-content'>
                                <QuestionComponent
                                    locale={this.state.locale}
                                    idPrefix={index}
                                    element={question}
                                    viewMode={this.viewMode()}
                                    handleChange={this.handleChange}
                                    validator={this.validator}
                                    onErrorMessage={(message) => this.showErrorMessage(message)}
                                    stateField={`element.translations[${this.state.locale}].questions[${index}]`}
                                    handleRemoveQuestion={this.handleRemoveQuestion}
                                    validateViewMode
                                    t={this.props.t}
                                    createNewAnswerOption={this.createNewAnswerOption}
                                    removeAnswerOption={this.removeAnswerOption}
                                    onAfterEditAnswerOptions={this.onAfterEditAnswerOptions}
                                    renderCoinsToEarn={true}
                                    renderPhoto={false}
                                    renderAnswerCorrectColumn={false}
                                    onAfterCoinEdition={this.onAfterCoinEdition}
                                />
                            </div>
                        </div>
                    );
                })}
                <div>
                    <div className='row'>
                        <div className='col-12'>
                            <ActionButton
                                label={t('welcome-survey.addQuestionHeader')}
                                className='float-right'
                                key={'next-button'}
                                handleClick={(e) => this.handleAddQuestion()}
                                rendered={
                                    this.viewMode() !== 'VIEW' && this.state.element?.translations[this.state.locale]?.questions?.length > 0
                                }
                            />
                        </div>
                    </div>
                    <hr id='line-separator' />
                </div>
            </DivContainer>
        );
    }
}

WelcomeSurveyContainer.defaultProps = {
    backUrl: '/welcome-survey-list',
    editUrl: '/welcome-survey/edit',
    detailUrl: '/welcome-survey/details',
    lazy: true,
};

WelcomeSurveyContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(withTranslation()(WelcomeSurveyContainer));
